// class VideoPlayer {
//   constructor(params) {
//     this.video = document.querySelector(params.video);
//     this.button = document.querySelector(params.button);
//     this.bannerContent = document.querySelector(params.bannerContent);
//     this.poster = document.querySelector(params.poster);
//     this.addEventListeners();
//   }
//   playPause() {
//     this.button.classList.toggle("playing");
//     this.poster.classList.toggle("hidden");
//     if (this.bannerContent) {
//       this.bannerContent.classList.toggle("hidden");
//     }
//     if (this.video.paused) {
//       this.video.play();
//     } else {
//       this.video.pause();
//     }
//   }
//   reset() {
//     this.button.classList.remove("playing");
//     this.poster.classList.remove("hidden");
//     if (this.bannerContent) {
//       this.bannerContent.classList.remove("hidden");
//     }
//   }
//   addEventListeners() {
//     this.button.addEventListener("click", this.playPause.bind(this));
//     this.poster.addEventListener("click", this.playPause.bind(this));
//     this.video.addEventListener("ended", this.reset.bind(this));
//   }
// }

class PlayPauseButton extends HTMLElement {
  constructor() {
    super();
    this.playIcon = null;
    this.pauseIcon = null;
    this.video = null;
    this.onClick = this.onClick.bind(this);
    this.updateIcons = this.updateIcons.bind(this);
  }
  connectedCallback() {
    // Get video selector from attribute (support both 'for' and 'data-video')
    const videoSelector = this.getAttribute("data-video");

    // Find video element
    if (videoSelector) {
      this.video = document.querySelector(videoSelector);
    }

    // Get icon elements
    this.playIcon = this.querySelector(".icon-play");
    this.pauseIcon = this.querySelector(".icon-pause");

    // Add event listeners
    this.addEventListener("click", this.onClick);

    if (this.video) {
      this.video.addEventListener("play", this.updateIcons);
      this.video.addEventListener("pause", this.updateIcons);
      this.video.addEventListener("ended", this.updateIcons);
      this.updateIcons();
    }
  }
  disconnectedCallback() {
    this.removeEventListener("click", this.onClick);
    if (this.video) {
      this.video.removeEventListener("play", this.updateIcons);
      this.video.removeEventListener("pause", this.updateIcons);
      this.video.removeEventListener("ended", this.updateIcons);
    }
  }
  onClick(event) {
    if (!this.video) return;
    event.preventDefault();
    event.stopPropagation();
    if (this.video.paused) {
      this.video.play();
    } else {
      this.video.pause();
    }
  }
  updateIcons() {
    if (!this.playIcon || !this.pauseIcon || !this.video) return;
    if (this.video.paused) {
      this.playIcon.classList.remove("hidden");
      this.pauseIcon.classList.add("hidden");
    } else {
      this.playIcon.classList.add("hidden");
      this.pauseIcon.classList.remove("hidden");
    }
  }
}
if (!customElements.get("play-pause")) {
  customElements.define("play-pause", PlayPauseButton);
}
